import React from 'react';
import { useTranslation } from 'react-i18next';
import './DestinationsHero.css';

const DestinationsHero: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <div className="destinations-hero" data-name="Page Header" id="node-439_15964">
      <div className="hero-container">
        <h1>
          {t('pages/destinations:hero.title')}
        </h1>
      </div>
    </div>
  );
};

export default DestinationsHero;